export const TRACKING_KEY_SAVE_FOR_LATER = "tracking.productList.saveForLater";
export const TRACKING_CONTEXT_SAVE_FOR_LATER = "saveForLater";
export const TRACKING_WORD_DELIMITER = "%$";
export const TRACKING_CATEGORY_PAGE_TYPE = "category";
